import * as React from 'react';
import {
  ISharedAppContextV2,
  SharedAppContextV2Consumer,
  SharedAppContextV2Provider,
} from '@origin-digital/shared-app-context';
import { getEnvironment, getHomepageUrl } from '../config/ConfigService';

const SharedAppContextPageV2: React.FC = () => (
  <>
    <SharedAppContextV2Provider
      xhrInitialize={true}
      environment={getEnvironment()}
      xhrHost={getHomepageUrl()}
    >
      <SharedAppContextV2Consumer>
        {(context: ISharedAppContextV2) => {
          // tslint:disable-next-line:no-console
          return context.originCustomerId ? (
            <div>
              <h1>New context</h1>
              <p>BPID: {context.businessPartnerId}</p>
              <p>Premiseid: {context.premiseId}</p>
              <p>originCustomerId: {context.originCustomerId}</p>
              <p>AddressId: {context.selectedAddressId}</p>
              <p />
              <p>addresses:</p>
              {context.addresses.map((a) => (
                <>
                  <p>|--id: {a.id}</p>
                  <p>|--qasId: {a.qasId}</p>
                  <p>|--name: {a.name}</p>
                  <p>|--postcode: {a.postcode}</p>
                  <p>|--primary: {a.primary}</p>
                  <p>|--state: {a.state}</p>
                  {a.services.map((s) => (
                    <>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--id: {s.id}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--backendId: {s.backendId}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--type: {s.type}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--status: {s.status}</p>
                    </>
                  ))}
                </>
              ))}
              <p />
              <p>properties:</p>
              {context.properties.map((a) => (
                <>
                  <p>|--premiseId: {a.premiseId}</p>
                  <p>|--addressId: {a.addressId}</p>
                  <p>|--premiseName: {a.premiseName}</p>
                  <p>|--premisePrimary: {a.premisePrimary}</p>
                  <p>|--state: {a.state}</p>
                  {a.contractAccounts.map((s) => (
                    <>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--contractAccountId: {s.contractAccountId}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--divisionCode: {s.divisionCode}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--status: {s.status}</p>
                    </>
                  ))}
                </>
              ))}
            </div>
          ) : (
            <div>
              <h1>New context</h1>
              <p>no origin id</p>
            </div>
          );
        }}
      </SharedAppContextV2Consumer>
    </SharedAppContextV2Provider>
  </>
);

export { SharedAppContextPageV2 };
